import React, { useContext, useState, useCallback } from "react";
import Card from "../UI/Card";
import { Link, useNavigate } from "react-router-dom";
import AppContext from "../../store/app-context";
import AuthContext from "../../store/auth-context";
import useHttp from "../../hooks/use-http";

import styles from "./RequestForQuote.module.css";
import Button from "../UI/Button";

const RequestForQuote = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("Error fetching data...");
  const [isAPIError, setIsAPIError] = useState(false);
  const [isRfqUpdate, setIsRfqUpdate] = useState(false);
  const {
    isLoadingGetQuote,
    errorGetQuote,
    sendRequest: updateLineItems,
  } = useHttp();

  const navigate = useNavigate();

  const authCtx = useContext(AuthContext);
  const appCtx = useContext(AppContext);

  let label_quoteSummary = 'Quote summary';
  let label_allItemsUpdate = 'Apply All Item Updates';
  let label_subtotal = 'Subtotal';
  let label_Total = 'Total';
  let label_startQuoteRequest = 'Start a Quote Request';
  let label_needHelp = 'Need Help Placing an Quote?';
  let label_vewFAQ = 'View our Quote FAQ';
  let label_items = 'items';
  let label_addItemsToCart = 'Add all items to cart';
  let label_quotedShipping = 'Quoted Shipping';
  let label_quotedPackaging = 'Quoted Packaging';
  let label_placeOrder = 'Place order';
  let createQuote = 'Create new quote';
  let renewQuotes = 'Renew quote';

  if(appCtx && appCtx.bioradResources){
    label_quoteSummary = appCtx.bioradResources.Quote_Summary ? appCtx.bioradResources.Quote_Summary : 'Quote summary';
    label_allItemsUpdate = appCtx.bioradResources.Apply_Item_Updates ? appCtx.bioradResources.Apply_Item_Updates : 'Apply All Item Updates';
    label_subtotal = appCtx.bioradResources.Cart_Subtotal ? appCtx.bioradResources.Cart_Subtotal : 'Subtotal';
    label_Total = appCtx.bioradResources.Cart_Total ? appCtx.bioradResources.Cart_Total : 'Total';
    label_startQuoteRequest = appCtx.bioradResources.Start_Quote_Request ? appCtx.bioradResources.Start_Quote_Request : 'Start a Quote Request';
    label_needHelp = appCtx.bioradResources.Quote_Need_Help ? appCtx.bioradResources.Quote_Need_Help : 'Need Help Placing an Quote?';
    label_vewFAQ = appCtx.bioradResources.View_Quote_FAQ ? appCtx.bioradResources.View_Quote_FAQ : 'View our Quote FAQ';
    label_items = appCtx.bioradResources.Cart_Items ? appCtx.bioradResources.Cart_Items : 'items';
    label_addItemsToCart = appCtx.bioradResources.Add_All_Items_To_Cart ? appCtx.bioradResources.Add_All_Items_To_Cart : 'Add all items to cart';
    label_quotedShipping = appCtx.bioradResources.Quoted_Shipping ? appCtx.bioradResources.Quoted_Shipping : 'Quoted Shipping';
    label_quotedPackaging = appCtx.bioradResources.Quote_Packaging ? appCtx.bioradResources.Quote_Packaging : 'Quoted Packaging';
    label_placeOrder = appCtx.bioradResources.PlaceOrder ? appCtx.bioradResources.PlaceOrder : 'Place order';
    createQuote = appCtx.bioradResources.Create_Quote ? appCtx.bioradResources.Create_Quote : 'Create new quote';
    renewQuotes = appCtx.bioradResources.RenewQuote ? appCtx.bioradResources.RenewQuote : 'Renew quote';
  }

  let totalItem = 0;
  if(props && props.quote && props.quote.quoteLineEntityList && props.quote.quoteLineEntityList.length > 0){
      props.quote.quoteLineEntityList.forEach((item) => (
          totalItem = totalItem + parseInt(item.quantity)
      ));
  }

  const webRef = props.quote && props.quote.webReference ? "/"+props.quote.webReference : "";
  const loginUrl = appCtx.envProp.loginUrl + appCtx.envProp.appServer + appCtx.envProp.appName + webRef + "&ui_locales=" + appCtx.lang;

    let itemIds = "";
    let qtys = "";
    if(props && props.itemChanges){
      props.itemChanges.map((item) => {
        itemIds += item.itemId + ",";
        qtys += item.qty + ",";
      });
  }

  const itemChangeHandler = useCallback(async (navigateUrl) => {
    if (itemIds !== "" && qtys !== "") {
      setIsLoading(true);
      const setQuoteData = (quoteData) => {
        setIsLoading(false);
        setIsRfqUpdate(true);
      };
      updateLineItems(
        {
          url:
            "/quoteservices/rfqs/items/" +
            props.quote.webReference +
            "?itemIds=" +
            itemIds +
            "&qtys=" +
            qtys,
          method: "post",
          headers: { "Content-type": "application/text" },
        },
        setQuoteData,
        "json"
      ).catch((error) => {
        if (error && error.message) {
          setErrorMsg(error.message);
        }
        setIsAPIError(true);
        setIsLoading(false);
      });
    }
    window.location.href = navigateUrl;

  },[itemIds, qtys])

  let referenceNumber = null;
  if(props && props.quote){
    referenceNumber = props.quote.quoteId ? props.quote.quoteId : props.quote.webReference;
  }

  const shoppingCartURL =
    appCtx.envProp.appServer +
    "bc/" +
    appCtx.lang.toLowerCase() +
    "-" +
    appCtx.country.toLowerCase() +
    "/addCartByQuote?quoteIdForCart=" +
    referenceNumber;

  const quoteFQAURL =
    appCtx.envProp.webServer +
    appCtx.lang.toLowerCase() +
    "-" +
    appCtx.country.toLowerCase() +
    "/quote-faq";

  return (
    <Card className={`${props?.isNew==='true'? styles.newRfq:''} ${styles.rfq}`}>
      <div className={styles.ordersummary}>
        {props?.isNew === 'true' ? (
          <h3 className={styles.newheadertitle}>{label_quoteSummary}</h3>
        ) : (
          <p className={styles.headertitle}>{label_quoteSummary}</p>
        )}
        <p className={styles.labelAllItems}>{label_allItemsUpdate}</p>
        <span className={styles.price}>
          {label_subtotal} ({totalItem} {label_items}):
        </span>
        {props?.quote?.formattedSubTotalPrice && (
          <span className={styles.price}>
            {props.quote.formattedSubTotalPrice}
          </span>
        )}
      </div>
      {(props?.quote?.formattedFreightQuoted ||
        props?.quote?.fromattedPackagingQuoted) && (
        <div className={styles.ordersummary}>
          {props?.quote?.formattedFreightQuoted && (
            <div>
              <span className={styles.price}>{label_quotedShipping}:</span>
              <span className={styles.price}>
                {props.quote.formattedFreightQuoted}
              </span>
            </div>
          )}
          {props?.quote?.fromattedPackagingQuoted && (
            <div>
              <span className={styles.price}>{label_quotedPackaging}:</span>
              <span className={styles.price}>
                {props.quote.fromattedPackagingQuoted}
              </span>
            </div>
          )}
        </div>
      )}
      <div className={styles.ordersummary}>
        <span className={props?.isNew === 'true'?styles.total:styles.heading_3}>{label_Total}</span>
        <span className={props?.isNew === 'true'?styles.total:styles.heading_3}>{props.total}</span>
      </div>
      {authCtx.isLoggedIn && props.isEditable && (
        <>
          <div>
            {props.quote && (
              <Link
                to="/additional-info"
                className={styles.anchorBtn}
                state={{
                  quote: props.quote,
                  itemChanges: props.itemChanges,
                  acctInfo: props.acctInfo,
                }}
              >
                {label_startQuoteRequest}
              </Link>
            )}
          </div>

          <div className={styles.heading_3}>{label_needHelp}</div>
          <div className={styles.text}>
            <a href={quoteFQAURL} className={styles.btnlinkU}>
              {label_vewFAQ}
            </a>
          </div>
        </>
      )}
      {authCtx.isLoggedIn &&
        !props.isEditable &&
        props.quote.isExpired &&
        props.quote.canRenewOrCopy &&
        !props.quote.isRenewable && (
          <div>
            <Button className={props?.isNew === 'true'?styles.primaryButton:''} onClick={props.copyQuoteHandler}>{createQuote}</Button>
          </div>
        )}
      {authCtx.isLoggedIn &&
        !props.isEditable &&
        !props.isRenewed &&
        props.quote.isExpired &&
        props.quote.canRenewOrCopy &&
        props.quote.isRenewable && (
          <div>
            <Button className={props?.isNew === 'true'?styles.primaryButton:''} onClick={props.renewQuoteHandler}>{renewQuotes}</Button>
          </div>
        )}
      {authCtx.isLoggedIn &&
        !props.isEditable &&
        referenceNumber &&
        props.quote.canAddQuoteToCart && (
          <div>
            <form action={shoppingCartURL} method="post">
              <input type="hidden" name="Operation" value="AddQuoteToCart" />
              <input
                type="hidden"
                name="quoteIdForCart"
                value={referenceNumber}
              />
              <Button className={props?.isNew === 'true'?styles.primaryButton:''} type="submit">{props?.isNew === 'true'?label_placeOrder:label_addItemsToCart}</Button>
            </form>
          </div>
        )}
      {!authCtx.isLoggedIn && (
        <div>
          <p>
            <Button className={props?.isNew === 'true'?styles.primaryButton:''} onClick={() => itemChangeHandler(loginUrl)}>
              {label_startQuoteRequest}
            </Button>
            <div className={styles.heading_3}>{label_needHelp}</div>
            <div className={styles.text}>
              <a href={quoteFQAURL} className={styles.btnlinkU}>
                {label_vewFAQ}
              </a>
            </div>
          </p>
        </div>
      )}
    </Card>
  );
};

export default RequestForQuote;
